import React from "react";
import "./ButtonIcon.scss";
const ButtonIcon = props => {
    const { onClick, className = "", text, showText = true, disabled, children } = props;
    return (
        <button className={"button button-icon " + className} onClick={onClick} title={text} disabled={disabled}>
            {showText && text}
            {children}
        </button>
    );
};

export default ButtonIcon;
